'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import DefaultErrorFallback from '@/components/internal/DefaultErrorFallback';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'errorBoundary',
        pathToFile: 'src/app/global-error.tsx',
      });

      scope.setLevel('error');

      Sentry.captureMessage(`Unhandled error: ${error.message}`);
    });
  }, [error]);

  return (
    // biome-ignore lint/a11y/useHtmlLang: This is a global error-fallback UI.
    <html>
      <body>
        <DefaultErrorFallback />
      </body>
    </html>
  );
}
